'use strict'


const _ = require('lodash')

const CSS_UNITS = {
    pct: '%',
    px: 'px',
    vw: 'vw',
    vh: 'vh'
}

const rgbaRegexp = /^\d+,\d+,\d+,(\d+.?\d*)?/


function parseFontStr(fontStr) {
    const split = fontStr.split(' ')
    const sizeSplit = split[3] ? split[3].split('/') : []
    return {
        style: split[0],
        variant: split[1],
        weight: split[2],
        size: sizeSplit[0],
        lineHeight: sizeSplit[1],
        family: split[4].replace(/\+/g, ' '),
        color: split[5],
        bold: split[2] === 'bold' || parseInt(split[2], 10) >= 700,
        italic: split[0] === 'italic'
    }
}

function fromTextThemeToFontStyle(textTheme) {
    return {
        style: textTheme.fontStyle,
        variant: textTheme.fontVariant,
        weight: textTheme.fontWeight,
        size: textTheme.fontSize,
        lineHeight: textTheme.lineHeight,
        letterSpacing: textTheme.letterSpacing,
        family: textTheme.fontFamily.replace(/[+]/g, ' '),
        color: textTheme.color,
        bold: ['bold', 'bolder'].includes(textTheme.fontWeight),
        italic: textTheme.fontStyle === 'italic'
    }
}

module.exports = {
    parseFontStr,
    fromTextThemeToFontStyle
}
